export const zh = {
  title: '可重新造林地区天然林再生的碳积累潜力',
  subtitle: 'reforestable areas, 1 km, Cook-Patton et al. 2020',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: '功能',
      value: '在潜在的可重新造林地区，天然林再生的前 30 年中碳在地上活体生物量中的估计固存速率（Mg 碳/公顷/年）。',
    },
    {
      label: '分辨率',
      value: '1 × 1 km',
    },
    {
      label: '地理覆盖范围',
      value: '全球重新造林范围内（不含北部地区、草地生物群落和耕地）Griscom et al. 2017。',
    },
    {
      label: '来源',
      value:
        'Cook-Patton, S.C., S.M. Leavitt, D. Gibbs, N.L. Harris, K. Lister, K.J. Anderson-Teixeira, R.D. Briggs, R.L. Chazdon, T.W. Crowther, P.W. Ellis, H.P. Griscom, V. Herrmann, K.D. Holl, R.A. Houghton, C. Larrosa, G. Lomax, R. Lucas, P. Madsen, Y. Malhi, A. Paquette, J.D. Parker, K. Paul, D. Routh, S. Roxburgh, S. Saatchi, J.van den Hoogen, W.S. Walker, C.E. Wheeler, S.A. Wood, L. Xu, B.W. Griscom. 2020. Mapping carbon accumulation potential from natural forest regrowth. Nature, in press. https://www.nature.com/articles/s41586-020-2686-x. This work resulted from a collaboration between The Nature Conservancy, World Resources Institute, and 18 other institutions.',
    },
    {
      label: '更新频率',
      value: '',
    },
    {
      label: '内容日期',
      value: '适用于天然林再生的前 30 年。',
    },
    {
      label: '注意事项',
      value:
        '- 数值代表最佳估计值，但包含不确定性。结果的准确性取决于模型训练的数据可用性，这些数据主要集中在十个国家。与此数据层相关的不确定性地图可从 GFW 的开放数据门户网站下载。\n- 碳积累速率仅适用于天然林再生，不适用于其他积极的恢复方法（农林业、种植园等）。\n- 碳积累速率是线性的，在再生的前 30 年内进行了平均。30 年以外的延申将过高估计固存的碳量。\n- 速率仅反映地上活体生物量的碳积累。地下生物量、已死亡的有机物和土壤有机碳的积累不包括在内，但可根据要求提供地下碳积累地图。\n- 在稀树草原，速率仅适用于这类草原-森林交错区的森林部分。\n- 这些数据不能替代森林再生潜力的详细现场级评估。',
    },
    {
      label: '许可证',
      value: 'CC 4.0',
    },
  ],
  overview: {
    label: '概览',
    value: '',
  },
  citation: {
    label: '引用',
    value:
      'Cook-Patton et al. 2020. Carbon accumulation potential from natural forest regrowth in potentially reforestable areas. Accessed through Global Forest Watch 14/02/2025. www.globalforestwatch.org',
  },
};
